import { combineReducers } from 'redux';
import { REDUCER_ACCOUNTS } from '../constants/reducerNames';
import accountsReducer from './accountsReducer';

export default combineReducers({
    REDUCER_ACCOUNTS: accountsReducer
});